import React, { ReactNode } from 'react';

import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';

import { useTranslation } from '../../i18n';

function ScheduleCustomErrorState({
  onTryAgain,
  title,
}: {
  onTryAgain: () => void;
  title?: string | ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <EmptyState
      illustrationType={EmptyState.ILLUSTRATION_TYPES.CRANE_CONSTRUCTION_GREY}
      description={title || t('EMPTY_STATE.ERROR_ACTIVITIES_TITLE')}
    >
      <LinkButton onClick={onTryAgain}>{t('EMPTY_STATE.RETRY')}</LinkButton>
    </EmptyState>
  );
}

export default ScheduleCustomErrorState;
